import baseApi from "../../../shared/api/baseApi";
import { ResponseDto } from "../../../shared/dto/responseDto";

type SensorStatusNames = {
    list: SensorStatusNameDTO[];
}
type SensorStatusNameDTO = {
    parentCodeId: string;
    codeId: string;
    codeName: string;
    codeGroup: string;
    codeGroupName: string;
}

const sensorStatusNameApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getSensorStatusName: builder.query<SensorStatusNameDTO[], void>({
            query: () => ({
                url: "/cmn/sensor-status"
            }),
            transformResponse: (response: ResponseDto<SensorStatusNames>) => {
                return response.data.list;
            }
        })
    })
})

export type { SensorStatusNameDTO };
export type { SensorStatusNames };
export const { useGetSensorStatusNameQuery } = sensorStatusNameApi;
export {sensorStatusNameApi};